import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=1a2c4e26&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a2c4e26')) {
      api.createRecord('1a2c4e26', component.options)
    } else {
      api.reload('1a2c4e26', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=1a2c4e26&", function () {
      api.rerender('1a2c4e26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22ZQq1lHC3m6l/JS/comp/ImageCarousel.vue"
export default component.exports